<template>
  <div v-loading="isLoging">
    <el-dialog title="船舶统计" width="80%" top="5rem" :close-on-click-modal="false" :visible.sync="showDialog" :destroy-on-close="true" @close="close()">
      <div style="height: 100%">
        <el-form style="float: left" :inline="true" :model="formInline">
          <el-form-item label="统计时间类型:">
            <el-select v-model="formInline.timeType" placeholder="统计时间类型">
              <el-option label="周" value="1"></el-option>
              <el-option label="月" value="2"></el-option>
              <el-option label="季" value="3"></el-option>
              <el-option label="年" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getAlarmList">查询</el-button>
          </el-form-item>
        </el-form>
        <!--设备列表-->
        <el-table v-loading="loadingShow" element-loading-text="数据正在加载中..." :data="shipList" border style="width: 100%; font-size: 1rem">
          <el-table-column prop="shipName" label="船舶名称" align="center" />
          <el-table-column prop="shipCN" label="船舶CN码" align="center" />
          <el-table-column prop="shipMMSI" label="船舶MMSI" align="center" />
          <el-table-column prop="unSafeCount" label="不安全发生次数" align="center" />

          <el-table-column prop="camerashiftmonitoringCount" label="违规移动摄像头" align="center" />
          <el-table-column prop="gluedtophonemonitoringCount" label="人员玩手机" align="center" />
          <el-table-column prop="helmetwearingmonitoringCount" label="未带安全帽" align="center" />
          <el-table-column prop="intrusionmonitoringLeftCount" label="货仓闯入预警" align="center" />
          <el-table-column prop="intrusionmonitoringRightCount" label="人员上高预警" align="center" />
          <el-table-column prop="lifejacketdetectionCount" label="未穿救生衣" align="center" />
          <el-table-column prop="ondutymonitoringCount" label="无人值守" align="center" />
          <el-table-column prop="peopleaccompanymonitoringCount" label="未按规定陪岗交班" align="center" />
          <el-table-column prop="peoplepollingmonitoringCount" label="未按时巡检" align="center" />
          <el-table-column prop="smokefiremonitoringCount" label="烟火预警" align="center" />
          <el-table-column prop="smokingcallmonitoringCount" label="抽烟打电话预警" align="center" />
          <el-table-column prop="uniformnnCount" label="未穿工作服" align="center" />
          <el-table-column prop="captainCount" label="船长未监行预警" align="center" />
          <el-table-column prop="levelOneCount" label="一级预警数" align="center" />
          <el-table-column prop="levelTwoCount" label="二级预警数" align="center" />
          <el-table-column prop="levelThreeCount" label="三级预警数" align="center" />
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'shipDataTable',
  data() {
    return {
      level: 0,
      showDialog: false,
      loadingShow: false,
      isLoging: false,
      shipList: [],
      shipInfo: {},
      formInline: {
        timeType: '1'
      }
    }
  },
  methods: {
    openDialog: function (data) {
      this.showDialog = true
      this.shipInfo = data
      this.getAlarmList()
    },
    getAlarmList() {
      let that = this
      this.loadingShow = true
      this.$axios({
        method: 'get',
        url: `/api/ship/getCountType`,
        params: {
          timeType: this.formInline.timeType,
          shipId: this.shipInfo.shipId
        }
      })
        .then(function (res) {
          that.shipList = res.data.data
          that.loading = false
          that.loadingShow = false
          if (callback) callback()
        })
        .catch(function (error) {
          console.log(error)
          that.loading = false
          that.loadingShow = false
        })
    },
    close() {
      this.showDialog = false
      this.shipList = []
      this.formInline.timeType = '1'
      this.$parent.$refs.loadCamaer.showWindow()
    }
  }
}
</script>

<style scoped>
.info-header {
  background: #144578;
  height: 40px;
  color: #fff;
  display: flex;
  align-items: center;
  padding-left: 15px;
}
::v-build.infoDialog .el-dialog__header {
  padding: 0;
}
::v-build.infoDialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}
::v-build.infoDialog .el-dialog__headerbtn {
  top: 12px;
  right: 15px;
}
::v-build.el-tabs__content {
  display: flex;
  margin: 100px 0;
  justify-content: space-around;
}
.info-text {
  display: flex;
  flex-flow: column;
  text-align: justify;
  width: 40%;
  line-height: 2;
  color: black;
  font-size: 1.1rem;
}
.info-text div:not(:first-child) {
  margin-top: 10px;
}
.picuteBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.tab-footer {
  display: flex;
  justify-content: end;
}
::v-build.tab-footer .el-button--primary {
  background: #144578;
  border-color: #144578;
}
::v-build.tab-footer .el-button {
  padding: 8px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/shipDataTable.vue